<template>
    <div>
        <h1>Messages List</h1>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        computed: {}
    }

</script>
